import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss']
})
export class SkeletonComponent {
  @Input() height: string = 'auto';
  @Input() width: string = '100%';
  @Input() borderRadius: string = '4px';
  @Input() animation: 'pulse' | 'ripple' = 'ripple';
}
